import dispatcher from 'js/core/dispatcher';
import { authCode } from 'js/library/utils/API/authCode';

export const phoneInputAction = (dispatch, cellPhone) => {
  const path = window.parent.location.pathname === '/' ? '/inserirCodigo' : '/inserirCodigo';
  return dispatcher(
    dispatch,
    'PHONE_INPUT',
    authCode(cellPhone, path)
  );
};
